import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "mt-[60px] mb-[10px] w-full flex items-center gap-2"
};
const _hoisted_2 = {
  class: "content-expand",
  style: {
    "padding": "10px 20px",
    "white-space": "pre-wrap",
    "line-height": "1.5",
    "background-color": "#f9f9f9",
    "border-radius": "4px",
    "border-left": "3px solid #409eff"
  }
};
import { getIntDictOptions, DICT_TYPE } from '@/utils/dict';
import { dateFormatter } from '@/utils/formatTime';
import { KnowledgeSegmentApi } from '@/api/ai/knowledge/segment';
import KnowledgeSegmentForm from './KnowledgeSegmentForm.vue';
import { CommonStatusEnum } from '@/utils/constants';
import { useMessage } from '@/hooks/web/useMessage';
import { useRoute, useRouter } from 'vue-router';
import { onMounted, reactive, ref } from 'vue';
/** AI 知识库分段 列表 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'KnowledgeSegment'
  },
  __name: 'index',
  emits: ['back'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const message = useMessage(); // 消息弹窗
    const router = useRouter(); // 路由
    const route = useRoute(); // 路由
    const documentTitle = ref('');
    const loading = ref(true); // 列表的加载中
    const list = ref([]); // 列表的数据
    const total = ref(0); // 列表的总页数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10,
      documentId: undefined,
      content: undefined,
      status: undefined
    });
    const queryFormRef = ref(); // 搜索的表单
    /** 查询列表 */
    const getList = async () => {
      loading.value = true;
      try {
        const data = await KnowledgeSegmentApi.getKnowledgeSegmentPage(queryParams);
        list.value = data.list;
        total.value = data.total;
      } finally {
        loading.value = false;
      }
    };
    /** 搜索按钮操作 */
    const handleQuery = () => {
      queryParams.pageNo = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = () => {
      queryFormRef.value.resetFields();
      handleQuery();
    };
    /** 添加/修改操作 */
    const formRef = ref();
    const openForm = (type, id) => {
      formRef.value.open(type, id, queryParams.documentId);
    };
    /** 删除按钮操作 */
    const handleDelete = async id => {
      try {
        // 删除的二次确认
        await message.delConfirm();
        // 发起删除
        await KnowledgeSegmentApi.deleteKnowledgeSegment(id);
        message.success('删除成功');
        // 刷新列表
        await getList();
      } catch {}
    };
    /** 修改状态操作 */
    const handleStatusChange = async row => {
      try {
        // 修改状态的二次确认
        const text = row.status === CommonStatusEnum.ENABLE ? '启用' : '禁用';
        await message.confirm('确认要"' + text + '"该分段吗?');
        // 发起修改状态
        await KnowledgeSegmentApi.updateKnowledgeSegmentStatus({
          id: row.id,
          status: row.status
        });
        message.success('修改成功');
        // 刷新列表
        await getList();
      } catch {
        // 取消后，进行恢复按钮
        row.status = row.status === CommonStatusEnum.ENABLE ? CommonStatusEnum.DISABLE : CommonStatusEnum.ENABLE;
      }
    };
    __expose({
      initData: (documentId, title) => {
        queryParams.documentId = documentId;
        documentTitle.value = title || '';
        getList();
      }
    });
    /** 初始化 **/
    onMounted(() => {
      // 如果文档 ID 不存在，显示错误提示并关闭页面
      // if (!route.query.documentId) {
      //   message.error('文档 ID 不存在，无法查看分段列表')
      //   // 关闭当前路由，返回到文档列表页面
      //   router.push({ name: 'AiKnowledgeDocument' })
      //   return
      // }
      // // 从路由参数中获取文档 ID
      // queryParams.documentId = route.query.documentId as any
      // getList()
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          link: "",
          onClick: _cache[0] || (_cache[0] = $event => emits('back')),
          type: "primary",
          size: "large"
        }, {
          icon: _withCtx(() => [_createVNode(_component_Icon, {
            icon: "ri:arrow-go-back-line"
          })]),
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(documentTitle.value), 1)]),
          _: 1
        })]), _createVNode(_component_el_form, {
          class: "-mb-15px flex justify-between",
          model: queryParams,
          ref_key: "queryFormRef",
          ref: queryFormRef,
          inline: true,
          "label-width": "68px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
            label: "文档编号",
            prop: "documentId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.documentId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.documentId = $event),
              placeholder: "请输入文档编号",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-[240px]"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否启用",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: queryParams.status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.status = $event),
              placeholder: "请选择是否启用",
              clearable: "",
              class: "!w-[240px]"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).COMMON_STATUS), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: handleQuery
            }, {
              default: _withCtx(() => [_createVNode(_component_Icon, {
                icon: "ep:search",
                class: "mr-[5px]"
              }), _cache[6] || (_cache[6] = _createTextVNode(" 搜索"))]),
              _: 1
            })]),
            _: 1
          })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = $event => openForm('create'))
            }, {
              default: _withCtx(() => [_createVNode(_component_Icon, {
                icon: "ep:plus",
                class: "mr-5px"
              }), _cache[7] || (_cache[7] = _createTextVNode(" 添加切片 "))]),
              _: 1
            })), [[_directive_hasPermi, ['ai:knowledge:create']]])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          stripe: true,
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "分段编号",
            align: "center",
            prop: "id"
          }), _createVNode(_component_el_table_column, {
            type: "expand"
          }, {
            default: _withCtx(props => [_createElementVNode("div", _hoisted_2, [_cache[8] || (_cache[8] = _createElementVNode("div", {
              class: "content-title",
              style: {
                "margin-bottom": "8px",
                "color": "#606266",
                "font-size": "14px",
                "font-weight": "bold"
              }
            }, " 完整内容： ", -1)), _createTextVNode(" " + _toDisplayString(props.row.content), 1)])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "切片内容",
            align: "center",
            prop: "content",
            "min-width": "250px",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            label: "字符数",
            align: "center",
            prop: "contentLength"
          }), _createVNode(_component_el_table_column, {
            label: "token 数量",
            align: "center",
            prop: "tokens"
          }), _createVNode(_component_el_table_column, {
            label: "召回次数",
            align: "center",
            prop: "retrievalCount"
          }), _createVNode(_component_el_table_column, {
            label: "是否启用",
            align: "center",
            prop: "status"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row.status,
              "onUpdate:modelValue": $event => scope.row.status = $event,
              "active-value": 0,
              "inactive-value": 1,
              onChange: $event => handleStatusChange(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "创建时间",
            align: "center",
            prop: "createTime",
            formatter: _unref(dateFormatter),
            width: "180px"
          }, null, 8, ["formatter"]), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "120px"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => openForm('update', scope.row.id)
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode(" 编辑 ")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDelete(scope.row.id)
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 删除 ")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_Pagination, {
          total: total.value,
          page: queryParams.pageNo,
          "onUpdate:page": _cache[4] || (_cache[4] = $event => queryParams.pageNo = $event),
          limit: queryParams.pageSize,
          "onUpdate:limit": _cache[5] || (_cache[5] = $event => queryParams.pageSize = $event),
          onPagination: getList
        }, null, 8, ["total", "page", "limit"])]),
        _: 1
      }), _createVNode(KnowledgeSegmentForm, {
        ref_key: "formRef",
        ref: formRef,
        onSuccess: getList
      }, null, 512)], 64);
    };
  }
});